import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormControl from '@mui/material/FormControl';

import Typography from '@mui/material/Typography';

import SelectModel from './SelectModel';

import { useCopilotContext } from '../../contexts/CopilotContext';

const CopilotClassify = () => {
  const {
    homeSystemOptions,

    selectedClassifierOptions,
    setSelectedClassifierOptions,

    applyClassifier,
    setApplyClassifier,
  } = useCopilotContext();

  const [checkAll, setCheckAll] = useState<boolean>(false);
  const handleCheckboxAll = () => {
    setSelectedClassifierOptions(
      checkAll ? [] : homeSystemOptions.map((_, index) => index),
    );
    setCheckAll(!checkAll);
  };

  useEffect(() => {
    console.log(
      'selectedClassifierOptions changed...',
      selectedClassifierOptions,
    );

    if (selectedClassifierOptions.length && !applyClassifier.length)
      setApplyClassifier(['home_related', 'home_system']);
    if (!selectedClassifierOptions.length && applyClassifier.length)
      setApplyClassifier([]);
  }, [selectedClassifierOptions]);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //setApplyClassifier((prev:any) => {
    //  const a = prev.includes('home_related') ? prev : [...prev, 'home_related']
    //  return a.includes('home_system') ? a : [...a, 'home_system']
    //})

    /*
    setApplyClassifier((prev: string[]): string[] => {
      let updated = prev;
    
      if (!prev.includes('home_related')) {
        updated = [...updated, 'home_related'];
      }
    
      if (!updated.includes('home_system')) {
        updated = [...updated, 'home_system'];
      }
    
      return updated;
    })
    */
    //if (!applyClassifier.includes('home_related')) setApplyClassifier(['home_related', 'home_system'])

    const value = Number(event.target.value);
    //setSelectedClassifierOptions((prev:string[]):string[] => {
    //  return prev.includes(value) ? prev.filter(option => option !== value) : [...prev, value]
    //})

    setSelectedClassifierOptions(
      selectedClassifierOptions.includes(value)
        ? selectedClassifierOptions.filter((option) => option !== value)
        : [...selectedClassifierOptions, value],
    );
  };

  return (
    <>
      <Box style={{ marginTop: '1rem' }}>{<SelectModel />}</Box>

      <Box sx={{ padding: 2 }}>
        <Typography variant="h6">
          <Checkbox
            sx={{ padding: '.25rem' }}
            checked={checkAll}
            onChange={handleCheckboxAll}
            value={checkAll}
          />
          Home system:
        </Typography>
        <FormControl component="fieldset">
          <FormGroup>
            <Grid container spacing={0}>
              {homeSystemOptions.map(
                (option, index) =>
                  option !== '' && (
                    <Grid item xs={4} key={index}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            sx={{ padding: '.25rem', marginLeft: '2rem' }}
                            checked={selectedClassifierOptions.includes(index)}
                            onChange={handleCheckboxChange}
                            value={index}
                          />
                        }
                        label={option}
                      />
                    </Grid>
                  ),
              )}
            </Grid>
          </FormGroup>
        </FormControl>
      </Box>
    </>
  );
};

export default CopilotClassify;
